/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import { useTranslator } from '@jutro/locale';
import moment from 'moment';
import cx from 'classnames';

import messages from './MLDocumentTable.messages';
import styles from './MLDocumentTable.module.scss';

const DOCUMENT_READY_STATUS = 'final';
function MLDocumentTable(props) {
    const {
        documents
    } = props;
    const translator = useTranslator();

    const formatDate = (date) => {
        return date ? moment(date).format('MM/DD/YYYY') : '';
    }

    const documentReady = (document) => {
        return document.status === DOCUMENT_READY_STATUS;
    }

    const openDocument = (document) => {

    }

    const getDocumentTableRow = (item) => {
        return <div className="tablerow">
            <div className="cell ml-cell-width-15-percent">
                <span className={cx({'font-weight-bold': item.newToPortal_ML || item.newToPortal})}>
                    {formatDate(item.dateModified)}
                </span>
            </div>

            <div className="cell ml-cell-width-45-percent">
                <span className={cx({'font-weight-bold': item.newToPortal_ML || item.newToPortal})}>
                    {documentReady(item) && 
                        <a className="text-link" onClick={() => openDocument(item)} target="_blank">
                            {item.name}
                        </a>
                    }
                    {!documentReady(item) && <span>{item.name}</span>}
                    {(item.newToPortal_ML || item.newToPortal) && 
                        <span className="ml-pill ml-pill-default display-inline">
                            {translator(messages.NEW)}
                        </span>
                    }
                    { item.isActionRequired_ML && 
                        <span className="ml-pill ml-pill-error display-inline">
                            { translator(messages.ActionRequired) }
                        </span>
                    }
                </span>
            </div>

            <div className="cell ml-cell-width-25-percent">
                <span>{item.mimeTypeDescription_ML}</span>
            </div>

            <div className="cell ml-cell-width-15-percent">
                { documentReady(item) && item.documentSubType_Ext !== 'email' &&
                    <a className="text-link hide-mobile-stacking-max text-align-left"
                        onClick={() => openDocument(item)}
                        target="_blank">
                        {translator(messages.ViewPrint)}
                    </a>
                }
                { !documentReady(item) && item.documentSubType_Ext !== 'email' &&
                    <div className="disable-text">
                        {translator(messages.Generating)}
                    </div>
                }
                { item.documentSubType_Ext === 'email' &&
                    <div className="disable-text"></div>
                }
            </div>
        </div>
    }

    const getDocumentTable = () => {
        return  <div className="stack-table vertical-spacing-20">
            <div className="headerrow">
                <div className="cell ml-cell-width-15-percent">{translator(messages.Date)}</div>
                <div className="cell ml-cell-width-45-percent">{translator(messages.Document)}</div>
                <div className="cell ml-cell-width-25-percent">{translator(messages.Type)}</div>
                <div className="cell ml-cell-width-15-percent">{translator(messages.Actions)}</div>
            </div>
            {documents.map((document) => getDocumentTableRow(document))}
        </div>
    }

    const getNoDocumentsAvailable = () => {
        return <div className="gw-col-phone-12 text-center">
            <div>
                <span className="ml-no-docs ml-gag-lg">
                    {translator(messages.NoDocumentsAvailable)}
                </span>
            </div>
        </div>
    }

    return <div className="document-table ml-document-table">
        {documents && documents.length > 0 && getDocumentTable()}
        {(!documents || documents.length === 0) && getNoDocumentsAvailable()}
    </div>
    
    
}

export default MLDocumentTable;
